<template>
  <section v-if="results" class="results-list">

    <!-- aggregations -->
    <portal to="outer" v-if="showAggregations">
      <NotificationAggregations v-model="showAggregations" :aggs="results.aggs" />
    </portal>
    <!-- eo:aggregations -->

    <!-- counter -->
    <div class="counter">
      <b-taglist>
        <b-tag v-if="typeof results.aggs === 'object' && (results.aggs.dayOfWeek||[]).length > 0"
          @click="showAggregations = true"
          rounded class="is-light mr-2 is-clickable">
          <font-awesome-icon icon="chart-column"/>
        </b-tag>
        <b-tag v-if="highlight" @click="showHighlighted" rounded class="is-primary is-light is-clickable is-small mr-2">
          Jump to notification
        </b-tag>
        <b-tag rounded class="is-light mr-2">
          Found {{ results.totalHits.toLocaleString() }} notifications
        </b-tag>
      </b-taglist>
    </div>
    <!-- eo:counter -->

    <!-- todo:aggs -->
    <!-- eo:todo:aggs -->

    <!-- list -->
    <div class="listing">
      <div v-for="(n, i) in results.notifs" :key="i"
        :class="`item ${highlightPrefixFinal}-${n.metaData._id} ${n.metaData._id === highlight ? 'highight' : ''}`">

        <!-- fake deviceId grouping -->
        <NotificationHeader
          v-if="i == 0 || n.deviceId !== results.notifs[i-1].deviceId"
          :n="n"
          />
        <!-- eo:fake deviceId grouping -->

        <!-- show the notification -->
        <NotificationViewer :n="n" />
        <!-- eo:show the notification -->

      </div>
    </div>
    <!-- eo:list -->

  </section>
</template>

<script>
import NotificationViewer from './notifications/NotificationViewer.vue'
import NotificationAggregations from '@/components/notifications/aggregations/NotificationAggs.vue'
import NotificationHeader from './NotificationHeader.vue'
import { toastDanger } from '@/services/prompts'
import { showElementByQuery } from '@/services/browser/automate'

export default {
  components: { NotificationViewer, NotificationHeader, NotificationAggregations },
  props: {
    results: Object,
    highlight: String,
    highlightPrefix: String,
  },
  data () {
    return {
      showAggregations: false,
    }
  },
  computed: {
    highlightPrefixFinal () { return this.highlightPrefix || 'n' }
  },
  methods: {
    showHighlighted () {
      if (!this.highlight) return
      if (!showElementByQuery(`.${this.highlightPrefixFinal}-${this.highlight}`)) {
        toastDanger(this, 'Unable to locate notification')
      }
    }
  }
}
</script>